<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-page.jpg?v=123')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="60%"
          max-width="700"
          width="100%"
        >
          <base-heading title="Julibee Employment Pte Ltd" />

          <base-body>
            Julibee Employment Pte Ltd - Bring Care to Your Home.<br />
            Your trusted partner in supply of household manpower services.
            Established since 2018, but with experience way before that. We
            provides reliable service and supply of confinement nanny, domestic
            helpers, cleaning services, and confinement meal. We will be glad to
            service your household.
          </base-body>

          <div
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'flex-column align-start'
                : 'align-center'
            "
            class="d-flex flex-wrap"
          >
            <base-btn href="../our-service" color="orange darken-1">
              Services
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              color="orange darken-1"
              text
              href="../contact-us"
            >
              Contact us
            </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
export default {
  name: "SectionHero",

  provide: {
    theme: { isDark: true }
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    }
  }
};
</script>
